import React from 'react';
import { useLocation } from 'react-router-dom';
import { CheckmarkIcon } from 'react-hot-toast';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import { Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Avatar,
    Typography,
    TablePagination,
    Button,
    Box
       } from '@mui/material';

const DataTable = () => {
    const location = useLocation();
    const data = location.state?.data || []; // Get the data passed via location state

    return (
        <div>
            <h1>API Data</h1>
            {data && data.length > 0 ? (
                <TableContainer component={Paper} sx={{ mt: 4 }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                        <TableRow>
                          <TableCell rowSpan={2} sx={{ backgroundColor: "dimgray", color: "white" }}>
                            S.No
                          </TableCell>
                          <TableCell rowSpan={2} sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Roll No.
                          </TableCell>
                          <TableCell rowSpan={2} sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Name
                          </TableCell>
                          <TableCell rowSpan={2} sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Father Name
                          </TableCell>
                          <TableCell rowSpan={2} sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Mother Name
                          </TableCell>
                          <TableCell rowSpan={2} sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Application No.
                          </TableCell>
                          <TableCell rowSpan={2} sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Date of Birth
                          </TableCell>
                          <TableCell rowSpan={2} sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Shift
                          </TableCell>
                          <TableCell rowSpan={2} sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Photo
                          </TableCell>
                          <TableCell colSpan={3} align="center" sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Exam Details
                          </TableCell>
                          <TableCell colSpan={5} align="center" sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Enrollment Details
                          </TableCell>
                          <TableCell colSpan={2} align="center" sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Biometric
                          </TableCell>
                          <TableCell rowSpan={2} sx={{ backgroundColor: "dimgray", color: "white" }}>
                            Status
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ backgroundColor: "dimgray", color: "white" }}>Exam Name</TableCell>
                          <TableCell sx={{ backgroundColor: "dimgray", color: "white" }}>Center Name</TableCell>
                          <TableCell sx={{ backgroundColor: "dimgray", color: "white" }}>Center Code</TableCell>
                          
                          <TableCell sx={{ backgroundColor: "dimgray", color: "white" }}>User Enrolled</TableCell>
                          <TableCell sx={{ backgroundColor: "dimgray", color: "white" }}>Enrollment Time</TableCell>
                          <TableCell sx={{ backgroundColor: "dimgray", color: "white" }}>Enrolled By</TableCell>
                          <TableCell sx={{ backgroundColor: "dimgray", color: "white" }}>Operator Name</TableCell>
                          <TableCell sx={{ backgroundColor: "dimgray", color: "white" }}>Is Present</TableCell>
                          
                          <TableCell sx={{ backgroundColor: "dimgray", color: "white" }}>Left</TableCell>
                          <TableCell sx={{ backgroundColor: "dimgray", color: "white" }}>Right</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                          {data.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell>{index + 1}</TableCell> {/* Serial Number */}
                              <TableCell>{row.rollNumber}</TableCell> {/* Roll Number */}
                              <TableCell>{row.name}</TableCell> {/* Name */}
                              <TableCell>{row.fatherName}</TableCell> {/* Father Name */}
                              <TableCell>{row.motherName}</TableCell> {/* Mother Name */}
                              <TableCell>{row.applicationNumber}</TableCell> {/* Application No. */}
                              <TableCell>{row.dob}</TableCell> {/* Date of Birth */}
                              <TableCell>{row.centerDetails?.shift}</TableCell> {/* Shift */}
                              <TableCell>
                                <Avatar src={row.photo} alt="Candidate Image" sx={{ width: 50, height: 50 }} />
                              </TableCell> {/* Candidate Photo */}
                              
                              {/* Exam Details */}
                              <TableCell>{row.centerDetails?.examName}</TableCell> {/* Exam Name */}
                              <TableCell>{row.centerDetails?.centerName}</TableCell> {/* Center Name */}
                              <TableCell>{row.centerDetails?.centerCode}</TableCell> {/* Center Code */}

                              {/* Enrollment Details */}
                              <TableCell>{row.enrollmentStatus?.userEnrolled ? "Yes" : "No"}</TableCell> {/* User Enrolled */}
                              <TableCell>{row.enrollmentStatus?.enrollmentTime}</TableCell> {/* Enrollment Time */}
                              <TableCell>{row.enrollmentStatus?.enrolledBy}</TableCell> {/* Enrolled By */}
                              <TableCell>{row.enrollmentStatus?.operatorName}</TableCell> {/* Operator Name */}
                              <TableCell>{row.enrollmentStatus?.isPresent ? "Yes" : "No"}</TableCell> {/* Is Present */}

                              {/* Biometric */}
                              <TableCell>
                                <Avatar src={row.enrollmentData?.thumbPicture} alt="Left Thumb" sx={{ width: 50, height: 50 }} />
                              </TableCell> {/* Left Thumb Picture */}
                              <TableCell>
                                <Avatar src={row.enrollmentData?.thumbPictureRight} alt="Right Thumb" sx={{ width: 50, height: 50 }} />
                              </TableCell> {/* Right Thumb Picture */}
                              
                              {/* Status */}
                              <TableCell>
                                {row.status === "success" ? (
                                  <CheckCircleOutlineIcon sx={{ color: "green" }} />
                                ) : (
                                  <WarningAmberIcon sx={{ color: "red" }} />
                                )}
                              </TableCell> {/* Status Icon */}
                            </TableRow>
                          ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <p>No data available</p>
            )}
        </div>
    );
};

export default DataTable;


// import React from 'react';
// import { useLocation } from 'react-router-dom';
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box } from '@mui/material';
// import WarningAmberIcon from '@mui/icons-material/WarningAmber';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

// // Define your column configuration
// const columns = [
//     { field: "name", headerName: "Name", width: 150 },
//     { field: "fatherName", headerName: "Father Name", width: 150 },
//     { field: "rollNumber", headerName: "Roll Number", width: 150 },
//     { field: "motherName", headerName: "Mother Name", width: 150 },
//     { field: "dob", headerName: "DOB", width: 150 },
//     { field: "applicationNumber", headerName: "Application Number", width: 150 },
//     { field: "photo", headerName: "Photo", width: 150 },
    
//     // Fields from centerDetails object
//     { field: "centerDetails.examName", headerName: "Exam Name", width: 150 },
//     { field: "centerDetails.centerName", headerName: "Center Name", width: 150 },
//     { field: "centerDetails.centerCode", headerName: "Center Code", width: 150 },
//     { field: "centerDetails.shift", headerName: "Shift", width: 150 },
//     { field: "centerDetails.shiftTime", headerName: "Shift Time", width: 150 },
//     { field: "centerDetails.shiftDate", headerName: "Shift Date", width: 150 },
  
//     // Fields from enrollmentStatus object
//     { field: "enrollmentStatus.userEnrolled", headerName: "User Enrolled", width: 150 },
//     { field: "enrollmentStatus.enrollmentTime", headerName: "Enrollment Time", width: 150 },
//     { field: "enrollmentStatus.enrolledBy", headerName: "Enrolled By", width: 150 },
//     { field: "enrollmentStatus.operatorName", headerName: "Operator Name", width: 150 },
//     { field: "enrollmentStatus.isPresent", headerName: "Is Present", width: 150 },
  
//     // Fields from enrollmentData object
//     { field: "enrollmentData.newPicture", headerName: "New Picture", width: 150 },
//     { field: "enrollmentData.thumbPicture", headerName: "Thumb Picture", width: 150 },
//     { field: "enrollmentData.enrollFingerIsoTemplate", headerName: "Finger Template", width: 150 },
//     { field: "enrollmentData.thumbPictureRight", headerName: "Thumb Right Picture", width: 150 },
  
//     {
//       field: "status", 
//       headerName: "Status", 
//       width: 150,
//       renderCell: (params) => {
//         const status = params.value;
//         return (
//           <Box sx={{
//             padding: "5px 10px",
//             borderRadius: "4px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}>
//             {status === "success" ? <CheckCircleOutlineIcon /> : <WarningAmberIcon />}
//           </Box>
//         );
//       }
//     }
//   ];
  

// const DataTable = () => {
//     const location = useLocation();
//     const data = location.state?.data || []; // Get the data passed via location state

//     return (
//         <div>
//             <h1>API Data</h1>
//             {data && data.length > 0 ? (
//                 <TableContainer component={Paper}>
//                     <Table sx={{ minWidth: 650 }} aria-label="simple table">
//                         <TableHead>
//                             <TableRow>
//                                 {columns.map((column) => (
//                                     <TableCell key={column.field} style={{ width: column.width }}>
//                                         {column.headerName}
//                                     </TableCell>
//                                 ))}
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {data.map((row, index) => (
//                                 <TableRow key={index}>
//                                     {columns.map((column) => (
//                                         <TableCell key={column.field}>
//                                             {column.renderCell ? column.renderCell({ value: row[column.field] }) : row[column.field]}
//                                         </TableCell>
//                                     ))}
//                                 </TableRow>
//                             ))}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>
//             ) : (
//                 <p>No data available</p>
//             )}
//         </div>
//     );
// };

// export default DataTable;

